
export interface CommunicationPreferences {
  emailEnabled: boolean;
  smsEnabled: boolean;
  surveyEnabled: boolean;
}

export enum CommunicationPrefUpdateResult {
  PROCESSED, QUEUED
}

